import { type AxiosInstance, type AxiosRequestConfig } from "axios";

import type {
  ApiShowResponse,
  Lawyer,
  LawyerPhoneNumber,
  LawyersGetRequestParameters,
  LawyersIndexResponse,
  LawyersPostRequestBody,
  LawyersPutRequestBody,
  ProfileCompletionStat,
} from "@ndpco/types";

export const getLawyers = async (
  axiosInstance: AxiosInstance,
  params?: LawyersGetRequestParameters
) => {
  return await axiosInstance.get<ApiShowResponse<LawyersIndexResponse>>(`/api/v1/user/lawyers`, {
    params: params,
  });
};

export const getLawyerByHandle = async (
  axiosInstance: AxiosInstance,
  handle: string,
  params?: LawyersGetRequestParameters
) => {
  return await axiosInstance.get<ApiShowResponse<Lawyer>>(`/api/v1/user/lawyers/${handle}`, {
    params: params,
  });
};

export const getLawyerPhoneNumber = async (
  axiosInstance: AxiosInstance,
  handle: string,
  params?: any
) => {
  return await axiosInstance.get<ApiShowResponse<LawyerPhoneNumber>>(
    `/api/v1/user/lawyers/${handle}/phone-number`,
    {
      params: params,
    }
  );
};

export const createLawyer = async (axiosInstance: AxiosInstance, data: LawyersPostRequestBody) => {
  return await axiosInstance.post("/api/v1/user/lawyers", data);
};

export const updateLawyer = async (
  axiosInstance: AxiosInstance,
  handle: string,
  data: LawyersPutRequestBody,
  config?: AxiosRequestConfig
) => {
  return await axiosInstance.patch(`/api/v1/user/lawyers/${handle}`, data, config);
};

export const updateLawyerVideo = async (
  axiosInstance: AxiosInstance,
  handle: string,
  data: FormData,
  config?: AxiosRequestConfig
) => {
  return await axiosInstance.post(
    `/api/v1/user/lawyers/${handle}`,
    { _method: "patch", ...Object.fromEntries(data.entries()) },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      ...config,
    }
  );
};

export const deleteLawyer = async (axiosInstance: AxiosInstance, id: number) => {
  return await axiosInstance.delete<ApiShowResponse<Lawyer>>(`/api/v1/user/lawyers/${id}`);
};

export const getLawyerProfileCompletionStats = async (
  axiosInstance: AxiosInstance,
  handle: string
) => {
  return await axiosInstance.get<ApiShowResponse<ProfileCompletionStat>>(
    `/api/v1/user/lawyers/${handle}/profile-completion-stat`
  );
};
